import Main from '@/views/administracion/contratos/configuracion/Main.vue';
import MainFirmas from '@/views/administracion/contratos/configuracion/firmas/Main.vue';
import MainPlantillas from '@/views/administracion/contratos/configuracion/plantillas/Main.vue';
import MainEtiquetas from '@/views/administracion/contratos/configuracion/etiquetas/Main.vue';

const auth = ['Contratos:ver'];
const scopes = ['Contratos:crear', 'Contratos:editar', 'Contratos:eliminar'];

const configuracion = [
  {
    path: 'configuracion',
    meta: {
      title: 'Configuración',
      auth,
    },
    component: Main,
    children: [
      {
        name: 'contratosConfiguracionFirmas',
        path: '/',
        meta: {
          title: 'Firmas',
          auth,
          scopes,
        },
        component: MainFirmas,
        children: [],
      },
      {
        name: 'contratosConfiguracionPlantillas',
        path: 'plantillas',
        meta: {
          title: 'Plantillas',
          auth,
          scopes,
        },
        component: MainPlantillas,
        children: [],
      },
      {
        name: 'contratosConfiguracionEtiquetas',
        path: 'etiquetas',
        meta: {
          title: 'Etiquetas',
          auth,
          scopes,
        },
        component: MainEtiquetas,
        children: [],
      },
    ],
  },
];

export default configuracion;
